<template lang="pug">
  #home
    GameSlide(v-for="game in games" :game="game")
</template>

<script>
import games from "@/data/games.json"
import GameSlide from "@/components/GameSlide.vue"

export default {
  name: 'Home',
  components: {
    GameSlide
  },
  data() {
    return {
      games: games.games
    }
  }
}
</script>